module.exports = __webpack_public_path__ + "img/logo.19c25d27.png";